export default [
  {
    path: '/admin/topic',
    name: 'indexTopicAdmin',
    meta: { title: 'indexTopicAdmin' },
    component: () => import('@/pages/admin/topic'),
  },
]
